import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

// ==========================================
// SECURITY MASK: Silence console in production/staging
// ==========================================
if (process.env.NODE_ENV === 'production') {
    const noOp = () => {};
    console.log = noOp;
    console.info = noOp;
    console.warn = noOp;
    console.debug = noOp;

    // Note: We leave console.error active so critical framework crashes
    // can still be picked up by your monitoring tools if needed.
}
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
